import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges, SimpleChange, ViewChild, ElementRef} from '@angular/core';
import {AssetService} from '../../shared/asset.service';
import {UserService} from '../../user/user.service';
import {DPUserService, DPSubscriptionService} from '../../portalv1';
import {VideoManageService} from './video-manage.service';
import {ToasterService} from 'angular2-toaster';
import {UserDetailsService} from '../../shared/user.details.service';
import {InAppNotificationsService} from '../../notifications/notifications.service';
import {ApiConstants} from '../../shared';
import {GeneralConstants} from '../../shared/general.constants';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';
import {QAService} from '../../catalogue/qa/qa.service';
import {VideoService} from '../model/video.service';
import {ClipboardService} from 'ngx-clipboard';

declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'video-manage',
    templateUrl: 'video-manage.component.html',
    styleUrls: ['video-manage.service.scss']
})
export class VideoManageComponent implements OnInit {
    @ViewChild('modal', {read: ElementRef}) modal: ElementRef;
    @Input() selectedShow;
    selectedConfidenceLevel: any;
    selectedPage: any;
    originalData;
    dataLoaded = false;
    @Output() selectedShowChange = new EventEmitter();
    tabs = ['High', 'Medium', 'Low'];
    selectedTab = 'High';
    editMode = false;
    isExternalUser = true;
    isHelpdeskAdmin = false;
    showComponent = false;
    editLoading = false;
    imdbChanged = [];
    importLoading = false;
    harvestedQARequest;
    rejectMessage = '';
    rejectModalLoading = false;
    genres = null;
    languages = null;
    languagesValues = null;
    countries = null;
    countriesValues = null;
    titlesToAdd = [];
    checkInInfo: any;
    private selectAll = false;
    private results = [];
    private hasMore = false;
    private hasResults = false;


    private verifyStatusValue = 'Approved';

    private verifyValues = ['Approved', 'Rejected', 'Pending'];

    private verifyStatusCheckBox = {
        verifyState: true,

    };
    private page = 1;
    private maxPages = 1;
    private imdb_id = undefined;
    private wikibase_id = undefined;
    private google_search = undefined;
    private totalResults;
    private confidenceBreakdown = [];
    private descriptionToBeShowed: string;
    private viewType: number = 0;
    private viewTypeValue = '0';
    private approvalType: number = 1;
    private approvalTypeValue = '1';
    private currentDate;
    private tagsToBeShowed;
    private currentYear;
    private givenYear;

    constructor(private clip: ClipboardService, private catalogService: CatalogService, private videoService: VideoService,
                public assetService: AssetService,
                private userService: UserService,
                private userDetailsService: UserDetailsService,
                private dpUserService: DPUserService,
                private catalogManageService: VideoManageService,
                private notificationService: InAppNotificationsService,
                private toasterService: ToasterService,
                private apiConstants: ApiConstants,
                private generalConstants: GeneralConstants,
                private qaService: QAService) {
    }


    onOriginalKeyUp(value, type, videoId) {
        switch (type) {
            case 'verifyState':
                this.verifyStatusValue = value;
                this.results = this.results.map((item) => {
                    if (item.video_id === videoId) {
                        item.human_verified = value;
                    }
                    return item;
                });
                break;
        }
    }

    onHumanVerfiedKeyUp(value, type, videoId) {
        switch (type) {
            case 'verifyState':
                this.verifyStatusValue = value;
                this.results = this.results.map((item) => {
                    if (item.video_id === videoId) {
                        item.human_verified = value;
                    }
                    return item;
                });
                break;
        }
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    ngOnInit(): void {
        if (localStorage.getItem('is_data_api_user') === 'true') {
            this.isExternalUser = false;
            this.dpUserService.getOwnUser().then(user => {
                if (
                    user.roles &&
                    user.roles.findIndex(x => x === 'Helpdesk Admin') > -1
                ) {
                    this.isHelpdeskAdmin = true;
                }
            });
        }

        // console.log(this.selectedShow);
        this.genres = Object.keys(this.apiConstants.GENRES) || [];
        this.languages = this.apiConstants.LANGUAGES.map(item => item.name);
        this.languagesValues = this.apiConstants.LANGUAGES.map(item => item.code);
        this.countries = this.apiConstants.COUNTRIES.map(item => item.displayName);
        this.countriesValues = this.apiConstants.COUNTRIES.map(item => item.iso);
    }

    // tslint:disable-next-line:use-life-cycle-interface member-ordering
    popup: boolean;

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedShow) {
            const selectedShow: SimpleChange = changes.selectedShow;
            if (selectedShow.currentValue) {
                if (selectedShow.currentValue.parrot_id) {
                    this.dataLoaded = false;
                    this.editMode = false;
                    this.page = 1;
                    this.showDetails(selectedShow.currentValue, 'HIGH', 1);
                } else {
                    this.hideDetails();
                }
            }

        }

        // if (changes.selectedShow) {
        //   this.results = this.selectedShow.currentValue;
        //   this.selectedShowChange.emit(this.results);
        //
        // }

    }

    isLoading(): boolean {
        return this.editLoading || this.rejectModalLoading || this.importLoading;
    }
    submitChanges() {
        const approvedUpdateQuery = [];
        const rejectedUpdateQuery = [];
        const nonmovieUpdateQuery = [];

        this.results = this.results.map((item) => {
            if (item.human_verified === 'APPROVED') {
                approvedUpdateQuery.push(item.video_id);
            }
            return item;
        });

        this.results = this.results.map((item) => {
            if (item.human_verified === 'REJECTED') {
                rejectedUpdateQuery.push(item.video_id);
            }
            return item;
        });

        this.results = this.results.map((item) => {
            if (item.human_verified === 'NONMOVIE') {
                nonmovieUpdateQuery.push(item.video_id);
            }
            return item;
        });


        const user = localStorage.getItem('userName');
        const queryJSON = {
            'user': user,
            'parrot_id': this.selectedShow.parrot_id,
            'title': (this.selectedShow.title).toLowerCase(),
            'approved_videos': approvedUpdateQuery,
            'rejected_videos': rejectedUpdateQuery,
            'nonmovie_videos': nonmovieUpdateQuery

        };

        this.videoService.updateVideoResults(
            JSON.stringify(queryJSON),
        ).then((res) => {


            if (res) {
                // console.log(res.status);
                // this.handleNextPage();
                if (this.totalResults > (this.page)) {
                    this.page = this.page;
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }

                this.dataLoaded = false;

                // if (this.hasMore) {
                if (this.selectedTab === 'Medium') {
                    this.showDetails(this.selectedShow, 'Med', this.page);
                } else {
                    this.showDetails(this.selectedShow, this.selectedTab, this.page);
                }
                // }else {
                //     this.allUpdated = true;
                // }

                // console.log(JSON.stringify(queryJSON));
                this.toasterService.pop('info', 'Successfully Updated the Videos');

                this.dataLoaded = true;
            } else {
                this.toasterService.pop('error', 'Failed to get video results');
                this.dataLoaded = false;
            }
        }).catch((err) => {
            console.error('Failed to get video results in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to get video results');
            this.dataLoaded = false;
        });


    }

    handleNextPage() {
        this.handleGoToPage(this.page + 1);
    }

    handlePreviousPage() {
        this.handleGoToPage(this.page - 1);
    }

    handleFirstPage() {
        this.handleGoToPage(1);
    }

    handleLastPage() {
        this.handleGoToPage(this.maxPages);
    }

    handleGoToPage(page) {
        this.selectAll = false;
        this.page = page;
        if (this.selectedTab === 'Medium') {
            this.showDetails(this.selectedShow, 'Med', this.page);
        } else {
            this.showDetails(this.selectedShow, this.selectedTab, this.page);
        }
    }

    approvedUpdateObject(data) {

        const propertiesArray = {
            'parrot_id': data.parrot_id,
            'video_id': data.video_id,
            'verified': data.human_verified,
        };
        return propertiesArray;
    }
    showDetails(show, confidenceLevel, pageNumber) {
        this.showComponent = true;
        this.selectedShow = show;
        this.selectedShowChange.emit(this.selectedShow);
        this.dataLoaded = false;
        this.getMetaData(show, confidenceLevel, pageNumber);
    }

    viewImdbId(value) {
        const newWindow = window.open('https://www.imdb.com/title/' + value);
    }

    viewWikibaseId(value) {
        const newWindow = window.open('https://www.wikidata.org/wiki/' + value);
    }

    viewGoogleSearch(value) {
        const newWindow = window.open('https://www.google.com/search?q=' + value);
    }

    async getMetaData(show, confidenceLevel, pageNumber) {

        this.currentDate = new Date().toISOString().slice(0, 10);
        const currentYear = new Date().getFullYear().toString();
        // tslint:disable-next-line:radix
        this.currentYear = parseInt(currentYear);
        try {
            if (this.selectedShow.imdb_id) {
                this.imdb_id = this.selectedShow.imdb_id;
            }
            if (this.selectedShow.wikibase_id) {
                this.wikibase_id = this.selectedShow.wikibase_id;
            }
            if (this.selectedShow.start_date) {
                // tslint:disable-next-line:max-line-length
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.original_country + ' ' + this.selectedShow.original_language + ' ' + this.selectedShow.start_date;
            } else if (this.selectedShow.release_year) {
                // tslint:disable-next-line:max-line-length
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.original_country + ' ' + this.selectedShow.original_language + ' ' + this.selectedShow.release_year;
            } else {
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.original_country + ' ' + this.selectedShow.original_language;
            }
        } catch (ex) {
            console.error('Fail to get links');
        }
        try {
            // tslint:disable-next-line:radix
            this.givenYear = parseInt(this.selectedShow.release_year);
        } catch (ex) {
            console.error('Fail to parse release year');
        }

        try {
            const value = this.viewType;
            let pageSize = 24;
            if (value === 1) {
                pageSize = 25;
            } else if (value === 2) {
                pageSize = 18;
            } else if (value === 3) {
                pageSize = 25;
            } else if (value === 0) {
                pageSize = 24;
            }

            const parrotID = show.parrot_id;
            this.videoService.getVideos(
                parrotID, confidenceLevel, pageNumber, pageSize
            ).then((res) => {
                // console.log(res);
                // console.log('Length',res.length);
                this.results = [];
                this.confidenceBreakdown = [];
                if (res.results.length > 0) {
                    this.hasResults = true;
                    this.results = this.results.concat(res.results.map(item => this.videoService.mapIndividualVideoResultItem(item, parrotID)));
                } else {
                    this.hasResults = false;
                }
                this.confidenceBreakdown = res.confidence_breakdown.map(item => this.videoService.mapIndividualConfidenceBreakdown(item));
                this.confidenceBreakdown = this.parseConfidenceBreakdown(this.confidenceBreakdown);
                this.totalResults = res.page_info.maxpage - 1;
                if (this.totalResults > (this.page)) {
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }
                this.dataLoaded = true;

            }).catch((err) => {
                this.dataLoaded = true;
                console.error('Failed to get video results in the catalog API' + err.toString());
                this.toasterService.pop('error', 'Failed to get video results');
            });

            this.originalData = jQuery.extend(true, {}, this.results);
            this.selectedShowChange.emit(this.results);
        } catch (error) {
            this.dataLoaded = true;
            // this.errorHandler(error);
        }
        ;
    }

    private parseConfidenceBreakdown(confidenceBreakdown) {

        let lowCount = 0;
        let lowApprovedCount = 0;
        let lowRejectedCount = 0;
        let lowPendingCount = 0;
        let highCount = 0;
        let highApprovedCount = 0;
        let highRejectedCount = 0;
        let highPendingCount = 0;
        let medCount = 0;
        let medApprovedCount = 0;
        let medRejectedCount = 0;
        let medPendingCount = 0;

        for (const value of confidenceBreakdown) {

            if (value.confidence_level === 'UNKNOWN' || value.confidence_level === 'LOW') {
                lowCount = lowCount + value.total_count;
                lowApprovedCount = lowApprovedCount + value.total_approved;
                lowRejectedCount = lowRejectedCount + value.total_rejected;
                lowPendingCount = lowPendingCount + value.total_pending;

            }
            if (value.confidence_level === 'VHIGH' || value.confidence_level === 'HIGH') {
                highCount = highCount + value.total_count;
                highApprovedCount = highApprovedCount + value.total_approved;
                highRejectedCount = highRejectedCount + value.total_rejected;
                highPendingCount = highPendingCount + value.total_pending;

            }
            if (value.confidence_level === 'MED') {
                medCount = medCount + value.total_count;
                medApprovedCount = medApprovedCount + value.total_approved;
                medRejectedCount = medRejectedCount + value.total_rejected;
                medPendingCount = medPendingCount + value.total_pending;
            }

            confidenceBreakdown = [
                {
                    'confidence_level': 'LOW',
                    'total_count': lowCount,
                    'total_approved': lowApprovedCount,
                    'total_rejected': lowRejectedCount,
                    'total_pending': lowPendingCount
                },
                {
                    'confidence_level': 'HIGH',
                    'total_count': highCount,
                    'total_approved': highApprovedCount,
                    'total_rejected': highRejectedCount,
                    'total_pending': highPendingCount
                },
                {
                    'confidence_level': 'MED',
                    'total_count': medCount,
                    'total_approved': medApprovedCount,
                    'total_rejected': medRejectedCount,
                    'total_pending': medPendingCount
                }
            ];
        }

        return confidenceBreakdown;
    }

    selectTab(tab) {
        this.selectedTab = tab;
        this.selectedConfidenceLevel = tab;
        this.page = 1;
        if (tab === 'Medium') {
            this.selectedConfidenceLevel = 'Med';
        }

        this.showDetails(this.selectedShow, this.selectedConfidenceLevel, this.page);
    }

    closeModal() {
        this.modal.nativeElement.style.display = 'none';
    }

    hideDetails() {
        this.showComponent = false;
    }

    handleSelectAll() {
        this.selectAll = !this.selectAll;
        this.results = this.results.map((item) => {
            item.selected = this.selectAll;
            item.human_verified = 'APPROVED';
            return item;
        });
    }

    handleRejectAll() {
        this.selectAll = !this.selectAll;
        this.results = this.results.map((item) => {
            item.selected = this.selectAll;
            item.human_verified = 'REJECTED';
            return item;
        });
    }

    handleClearAll() {
        if (this.selectedTab === 'Medium') {
            this.showDetails(this.selectedShow, 'Med', this.page);
        } else {
            this.showDetails(this.selectedShow, this.selectedTab, this.page);
        }
    }

    descriptionPopUp(event: boolean, description: string, tags: any) {

        this.popup = event;
        this.descriptionToBeShowed = description;
        this.tagsToBeShowed = tags;

    }

    onViewTypeChange(value: number) {
        this.viewType = value;

        if (value === 1) {
            this.viewTypeValue = '1';
        } else if (value === 2) {
            this.viewTypeValue = '2';
        } else if (value === 3) {
            this.viewTypeValue = '3';
        } else if (value === 0) {
            this.viewTypeValue = '0';
        }
    }

    onApprovalTypeChange(value: number) {
        this.approvalType = value;

        if (value === 1) {
            this.approvalTypeValue = '1';
        } else if (value === 2) {
            this.approvalTypeValue = '2';
        } else if (value === 3) {
            this.approvalTypeValue = '3';
        } else if (value === 0) {
            this.approvalTypeValue = '0';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/video-manage/video-manage.component.ts